<template>
  <section>
    <h1>Modules</h1>
    <p class="page-description">Once a ticket for the event is sold or someone registers, changes to the module will no longer be possible. Additionally, modifying the module will permanently delete certain settings, and this action cannot be undone.</p>
    <spinner v-if="loading" />
    <div v-else>
      <event-extra-modules
        :initial-values="form"
        :disable-editing="disableEditing"
        @update="handleUpdate"
      />
    </div>
    <simple-snackbar v-bind.sync="snackbar" />
  </section>
</template>

<script>
import { GET_EVENT_EXTRA_MODULES, UPDATE_EVENT_EXTRA_MODULES } from '@/graphql/event.graphql'
import EventExtraModules from '@/components/events/event-extra-modules.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'event-extra-modules-container',
  components: { SimpleSnackbar, EventExtraModules },
  props: {
    organizationSlug: String,
    eventId: String,
  },
  data() {
    return {
      form: {
        modules: {},
      },
      loading: true,
      disableEditing: false,
      snackbar: null,
    }
  },
  async mounted() {
    await this.fetchEventExtraModules()
  },
  methods: {
    async fetchEventExtraModules() {
      const { data: {getEvent: {extraModules}, eventHasPendingOrAllowedAttendees}, errors } = await this.$apollo.query({
        query: GET_EVENT_EXTRA_MODULES,
        variables: {
          id: this.eventId,
        },
      })
      if (errors || !extraModules) {
        return
      }
      this.loading = false
      this.form.modules = extraModules
      this.disableEditing = eventHasPendingOrAllowedAttendees
    },
    async handleUpdate() {
      const {errors} = await this.$apollo.mutate({
        mutation: UPDATE_EVENT_EXTRA_MODULES,
        variables: {
          eventId: this.eventId, extraModulesInput: this.form.modules,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'Cannot update modules.',
          color: 'error',
        }

        return
      }

      this.$router.go()
    },
  },
}
</script>


<style scoped>
section {
  max-width: 42.75rem;
}

h1 {
  color: #FF4C00;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.page-description {
  margin-top: 1rem;
  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 800px) {
  h1 {
    display: none;
  }
}
</style>
